<div [class.spinner--mono]="mono" [style.width]="width" class="spinner">
  <svg viewBox="25 25 50 50" class="spinner__circle">
    <circle cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" [attr.stroke-width]="strokeWidth" class="spinner__path"></circle>
  </svg>
</div>
